import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';
import colors from '../../styles/Colors';

interface Props {
  title?: string;
  subtitle?: string;
}

const AnalysisNotFound: React.FC<Props> = ({
  title = 'Lo sentimos, análisis no encontrado',
  subtitle = 'No pudimos localizar la información del análisis solicitado.',
}) => {
  const navigate = useNavigate();
  const handleBack = () => navigate(-1); // 👈 regresa a la página anterior

  return (
    <Box
      sx={{
        height: 'calc(100vh - 160px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 2,
        bgcolor: '#ffffffff',
        borderRadius: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: colors.colorPrimary, mb: 2 }} />
      <Typography variant="h4" component="h1" gutterBottom>
        {title}
      </Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {subtitle}
      </Typography>
      <Button
        variant="contained"
        sx={{ mt: 3, textTransform: 'none', backgroundColor: colors.colorPrimary }}
        onClick={handleBack}
      >
        Regresar
      </Button>
    </Box>
  );
};

export default AnalysisNotFound;
